import base from './apd.yaml';
import stateProfile from './stateProfile.yaml';

export default { ...base, stateProfile };
